import { css } from '@emotion/css'

import { fontSize, fontWeight, spacing, colors } from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    padding: spacing.large,
  }),

  text: css({
    fontSize: fontSize.default,
    color: colors.oxfordBlue,
    fontWeight: fontWeight.semiBold,
    margin: 0,
  }),

  list: css({
    marginTop: spacing.default,
  }),

  listItem: css({
    ':not(:first-child)': {
      marginTop: spacing.small,
    },

    '> * + *': {
      marginLeft: spacing.small,
    },
  }),
}

export default styles
